import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import useOutsideClick from '/src/hooks/useOutsideClick'
import onMenuOpen from '/src/helpers/onMenuOpen'

const Modal = ({ open, children, onClose }) => {
  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, onClose)

  useEffect(() => {
    onMenuOpen(open)
    return () => onMenuOpen(false)
  }, [open])

  if (!open) return null
  return (
    <div className='modal'>
      <div className='modal__container' ref={wrapperRef}>
        <div className='modal__close' onClick={onClose}>
          <div />
          <div />
        </div>
        <div className='modal__body'>{children}</div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.any,
}

export default Modal
